<template>
	<v-form v-model="valid" ref="form">
		<v-row>
			<v-col cols="12" md="12">
				<v-text-field
					v-model="nome"
					:rules="[
						$rules.required(),
						$rules.conterEspaco({ msg: 'Favor inserir nome completo' })
					]"
					label="Nome completo"
					required
					validate-on-blur
					autofocus
				/>
			</v-col>
		</v-row>
		<v-divider />
		<v-card-title>
			Exercícios
			<v-btn @click="novoExercicio" icon color="primary">
				<v-icon>mdi-plus</v-icon>
			</v-btn>
		</v-card-title>
		<v-row v-for="(exercicio, idx) in exercicios" :key="id + idx">
			<v-col class="pt-0 pb-0" cols="12" md="3">
				<v-select
					v-model="exercicio.parlamentarEsfera"
					:rules="[$rules.required()]"
					:items="esferaItems"
					label="Esfera"
					item-text="descricao"
					item-value="id"
					required
					return-object
					:readonly="exercicio.qtdEmendas > 0"
					:hint="
						exercicio.qtdEmendas > 0
							? 'Exercício com emendas não pode ser alterado ou removido'
							: ''
					"
				>
				</v-select>
			</v-col>
			<v-col class="pt-0 pb-0" cols="12" md="3">
				<v-text-field
					v-model="exercicio.dataInicio"
					:rules="[
						$rules.required(),
						$rules.validDate(),
						$rules.outOfIntervals({
							intervals: getIntervals(idx),
							startKey: 'dataInicio',
							endKey: 'dataFim',
							msg: 'Data já contida no intervalo ${dataInicio} e ${dataFim}'
						}),
						$rules.betweenDate({
							startKey: (exercicio.dataInicio == null ? '01/01/1900' : exercicio.dataInicio),
							endKey: (exercicio.dataFim == null ? '01/01/2200' : exercicio.dataFim),
							msg: 'Data inicial deve ser menor que data final'
						})
					]"
					v-mask="'##/##/####'"
					label="Data de Início"
					required
					:readonly="exercicio.qtdEmendas > 0"
					:hint="
						exercicio.qtdEmendas > 0
							? 'Exercício com emendas não pode ser alterado ou removido'
							: ''
					"
				>
				</v-text-field>
			</v-col>
			<v-col class="pt-0 pb-0" cols="12" md="3">
				<v-text-field
					v-model="exercicio.dataFim"
					v-mask="'##/##/####'"
					:rules="[
						$rules.required(),
						$rules.validDate(),
						$rules.outOfIntervals({
							intervals: getIntervals(idx),
							startKey: 'dataInicio',
							endKey: 'dataFim',
							msg: 'Data já contida no intervalo ${dataInicio} e ${dataFim}'
						}),
						$rules.betweenDate({
							startKey: (exercicio.dataInicio == null ? '01/01/1900' : exercicio.dataInicio),
							endKey: (exercicio.dataFim == null ? '01/01/2200' : exercicio.dataFim),
							msg: 'Data final deve ser maior que data inicial'
						})
					]"
					label="Data de Fim"
					required
				>
				</v-text-field>
			</v-col>
			<v-col class="pt-0 pb-0" cols="12" md="2">
				<v-text-field
					class="centered-input"
					label="Emendas"
					v-model="exercicio.qtdEmendas"
					placeholder="0"
					filled
					rounded
					dense
					readonly
				/>
			</v-col>
			<v-col
				class="pt-0 pb-0"
				cols="12"
				md="1"
				v-if="exercicios && exercicios.length > 1"
			>
				<v-btn
					icon
					outlined
					class="mt-3"
					@click="removerExercicio(idx)"
					:disabled="exercicio.qtdEmendas > 0"
					><v-icon>mdi-minus</v-icon></v-btn
				>
			</v-col>
		</v-row>
	</v-form>
</template>

<script>
export default {
	props: ['value'],

	data() {
		return {
			id: null,
			nome: null,
			exercicios: [{}],

			esferaItems: [],

			valid: null
		};
	},

	components: {},

	async created() {
		try {
			this.esferaItems = await this.$fetch.get(`parlamentares/esferas`);
		} catch (err) {
			this.$root.dialog = { title: 'Esferas não carregadas', msg: err.msg };
		}
	},

	watch: {
		value(parlamentar) {
			this.id = parlamentar.id;
			this.nome = parlamentar.nome;
			this.exercicios = parlamentar.exercicios;
			this.$nextTick(() => {
				this.$refs.form.validate();
			});
		},
		valid(value) {
			this.$emit('changeValid', value);
		},
		id() {
			this.atualizaParlamentar();
		},
		nome() {
			this.atualizaParlamentar();
		},
		exercicios: {
			deep: true,
			handler() {
				this.atualizaParlamentar();
			}
		}
	},

	methods: {
		async salvar() {
			this.$emit('salvando', true);
			await this.$refs.form.validate();

			let parlamentarSalvo;
			if (this.valid) {
				if (this.id) {
					try {
						parlamentarSalvo = await this.$fetch.put(
							`parlamentares/${this.id}`,
							this.value
						);
						this.$emit('updated', parlamentarSalvo);
					} catch (err) {
						this.$root.dialog = {
							title: 'Parlamentar não salvo',
							msg: err.msg
						};
					}
				} else {
					try {
						parlamentarSalvo = await this.$fetch.post(
							`parlamentares`,
							this.value
						);
						this.$emit('saved', parlamentarSalvo);
					} catch (err) {
						this.$root.dialog = {
							title: 'Parlamentar não salvo',
							msg: err.msg
						};
					}
				}
			}
			this.$emit('salvando', false);
			return parlamentarSalvo;
		},

		async remover() {
			this.$emit('removendo', true);

			let parlamentarRemovido;
			try {
				parlamentarRemovido = await this.$fetch.delete(
					`parlamentares/${this.id}`
				);
				if (parlamentarRemovido && parlamentarRemovido.id === this.value.id) {
					parlamentarRemovido = this.value;
				}
				this.$emit('removido', parlamentarRemovido);
			} catch (err) {
				this.$root.dialog = { title: 'Parlamentar não removido', msg: err.msg };
			}

			this.$emit('removendo', false);
			return parlamentarRemovido;
		},

		async obterParlamentar(id) {
			return this.$fetch.get(`parlamentares/${id}`);
		},
		limparCampos() {
			this.$refs.form.reset();
		},
		novoExercicio() {
			this.exercicios.splice(0, 0, {});
		},
		removerExercicio(index) {
			this.exercicios.splice(index, 1);
		},
		getIntervals(idx) {
			return this.exercicios.filter((ex, i) => idx !== i);
		},
		atualizaParlamentar() {
			this.$emit('input', {
				id: this.id,
				nome: this.nome,
				exercicios: this.exercicios
			});
		}
	}
};
</script>

<style scoped>
.centered-input >>> input {
	text-align: center;
}
.centered-input >>> label {
	right: -30px !important;
	text-align: center !important;
}
</style>
